import { useBrand } from '@contexts/index'
import { upperCaseFirst } from '@utils/helpers/stringHelpers'

import { CheckboxInput } from '../baseInputs'

const MarketingUnsubscribe = () => {
  const brand = useBrand()

  return (
    <div className="mt-8">
      <p className="mt-8 mb-4">
        Please note this does not unsubscribe you from any{' '}
        {upperCaseFirst(brand)} dealership databases as they operate as
        independent legal entities. Please contact any {upperCaseFirst(brand)}{' '}
        {brand === 'lexus' ? 'Centre' : 'dealerships'} you may have contacted
        previously to unsubscribe directly.
      </p>
      <h5 className={`${brand === 'lexus' ? 'text-lg' : 'font-medium '} mb-4`}>
        I&apos;d like to unsubscribe from:
      </h5>
      <CheckboxInput name={'consent.user'}>
        Communications - do not send me news, offers and events
      </CheckboxInput>
    </div>
  )
}

export default MarketingUnsubscribe
